var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 180.053,
    height: 60.326,
    viewBox: "0 0 180.053 60.326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_337",
    x: 0,
    y: 0,
    width: 76,
    height: 60.326,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_338",
    x: 14.235,
    y: 24.294,
    width: 47.666,
    height: 33.425,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33236",
    "data-name": "Group 33236",
    transform: "translate(-4802.534 84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33235",
    "data-name": "Group 33235",
    transform: "translate(4816.52 -69.874)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(1.015 0.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M277.266,2152.26l10.033,7.816a1.089,1.089,0,0,0,1.756-.864v-6.95",
    transform: "translate(-277.211 -2123.426)",
    fill: "#0dcea6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M343.689,2033.986v22.9a1.4,1.4,0,0,1-1.45,1.354H304.785a1.342,1.342,0,0,1-.782-2.495l37.916-22.667a1.155,1.155,0,0,1,1.769.906Z",
    transform: "translate(-297.706 -2027.965)",
    fill: "#ffd119"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)",
    filter: "url(#Path_337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337-2",
    "data-name": "Path 337",
    d: "M276,2007.282V2034.7a1.636,1.636,0,0,0,1.653,1.62h42.7a1.615,1.615,0,0,0,.891-2.985L278.017,2006.2a1.312,1.312,0,0,0-2.017,1.084Z",
    transform: "translate(-261 -1990.99)",
    fill: "#ff0935"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)",
    filter: "url(#Path_338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_338-2",
    "data-name": "Path 338",
    d: "M364.67,2116.116a1.686,1.686,0,0,0-1.63-1.695,1.748,1.748,0,0,0-1.709,1.712,1.709,1.709,0,0,0,1.69,1.646A1.66,1.66,0,0,0,364.67,2116.116Zm-8.8,1.691a1.666,1.666,0,0,0,1.645-1.674,1.7,1.7,0,0,0-1.645-1.687,1.748,1.748,0,0,0-1.7,1.722A1.714,1.714,0,0,0,355.87,2117.806Zm-7.163.04a1.672,1.672,0,0,0,1.647-1.677,1.71,1.71,0,0,0-1.655-1.685A1.744,1.744,0,0,0,347,2116.21,1.707,1.707,0,0,0,348.706,2117.846Z",
    transform: "translate(-317.77 -2078.13)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M409.16,2073.052l4.739-2.812,14.655,15.056Z",
    transform: "translate(-382.923 -2057.555)",
    opacity: 0.15
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33237",
    "data-name": "Group 33237",
    transform: "translate(-1.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M581.01,2026.464v14.873a1.843,1.843,0,1,1-3.685,0v-8.9l-3.384,5.32a1.977,1.977,0,0,1-1.746,1.175,2.005,2.005,0,0,1-1.747-1.175l-3.384-5.376v8.952a1.843,1.843,0,1,1-3.685,0v-14.873a1.812,1.812,0,0,1,1.8-1.912c.791,0,1.31.384,1.939,1.42l5.076,8.052,5.076-8.052c.655-1.036,1.145-1.419,1.939-1.419a1.81,1.81,0,0,1,1.8,1.912",
    transform: "translate(4311.624 -2084.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M709.659,2027.475v-10.4a1.842,1.842,0,1,1,3.684,0v10.4a1.842,1.842,0,1,1-3.684,0m4.148-16.867a2.307,2.307,0,1,1-2.293-2.238,2.272,2.272,0,0,1,2.293,2.238",
    transform: "translate(4186.713 -2070.373)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M772.207,2057.958a1.755,1.755,0,0,1-1.719,1.773,3.207,3.207,0,0,0-3.166,3.5v5.186a1.81,1.81,0,0,1-1.829,1.885,1.832,1.832,0,0,1-1.856-1.885v-10.4a1.8,1.8,0,0,1,1.829-1.854,1.766,1.766,0,0,1,1.774,1.661,4.408,4.408,0,0,1,3.3-1.527,1.575,1.575,0,0,1,1.665,1.663",
    transform: "translate(4140.075 -2111.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M846.063,2057.958a1.756,1.756,0,0,1-1.72,1.773,3.207,3.207,0,0,0-3.166,3.5v5.186a1.81,1.81,0,0,1-1.828,1.885,1.832,1.832,0,0,1-1.856-1.885v-10.4a1.8,1.8,0,0,1,1.829-1.854,1.767,1.767,0,0,1,1.774,1.661,4.4,4.4,0,0,1,3.3-1.527,1.575,1.575,0,0,1,1.665,1.663",
    transform: "translate(4076.808 -2111.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M907.858,2063.221a3.5,3.5,0,1,0,6.986,0,3.5,3.5,0,1,0-6.986,0m10.753-.027a7.137,7.137,0,0,1-7.285,7.069,7.057,7.057,0,1,1,7.286-7.069",
    transform: "translate(4019.732 -2111.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M1033.744,2057.958a1.755,1.755,0,0,1-1.72,1.773,3.207,3.207,0,0,0-3.166,3.5v5.186a1.81,1.81,0,0,1-1.828,1.885,1.832,1.832,0,0,1-1.856-1.885v-10.4a1.8,1.8,0,0,1,1.83-1.854,1.767,1.767,0,0,1,1.773,1.661,4.406,4.406,0,0,1,3.3-1.527,1.575,1.575,0,0,1,1.666,1.663",
    transform: "translate(3916.033 -2111.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M1104.936,2044.224v-16.646a.717.717,0,0,1,.736-.739h9.688a.641.641,0,0,1,.656.629.663.663,0,0,1-.656.653h-9.006v6.96h7.4a.641.641,0,0,1,.654.627.663.663,0,0,1-.654.655h-7.4v7.86a.735.735,0,0,1-.709.764.718.718,0,0,1-.709-.764",
    transform: "translate(3847.706 -2086.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M1202.59,2044.622v-16.891a.682.682,0,0,1,1.363,0v16.891a.66.66,0,0,1-.682.682.675.675,0,0,1-.682-.682",
    transform: "translate(3764.052 -2086.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M1248.536,2059.31a.808.808,0,0,1-.083.3l-6.386,14.356c-1.01,2.239-2.483,3.3-4.475,3.3a5.276,5.276,0,0,1-1.146-.107.663.663,0,0,1-.547-.626.635.635,0,0,1,.629-.63c.217,0,.627.111.955.111a3.43,3.43,0,0,0,3.3-2.4l.764-1.774-5.4-12.2a.834.834,0,0,1-.082-.326.677.677,0,0,1,.682-.686.7.7,0,0,1,.656.466l4.913,11.08,4.857-11.08a.707.707,0,0,1,.683-.466.7.7,0,0,1,.682.686",
    transform: "translate(3735.517 -2113.424)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.ed9f833b.svg";
export { ForwardRef as ReactComponent };